class SimilarityController {
   constructor($scope,$state,InfringementAPI,SimilarityCompareAPI, message, modal, $filter) {
       'ngInject';
       this.SimilarityCompareAPI = SimilarityCompareAPI
       this.message = message
       this.modal = modal
       this.translateFilter = $filter('translate')
       this.name = 'similarity';
       this.loading = false
       this.isEdit = "true"
       this.similarNum = 0;
       this.loadingCompare = false;
       this.InfringementAPI = InfringementAPI;
       if(this.articles) {
          this.loading = true;
          this.loadingCompare = true;
          this.loadComparedArticles(0);
       }
   }
   loadComparedArticles(time) {
      let self = this;
      this.InfringementAPI.one(this.articles).one("compare").one("article").one("content").get().then((result)=>{
         if(!result.data.infringement_content || result.data.infringement_content == ""  || 
            !result.data.source_content ||result.data.source_content == "") {
               console.log("article get error")
               throw "article get error";
         }
         self.loadingCompare = false;
         self.post1 = self.getText(result.data.source_content);
         self.post2 = self.getText(result.data.infringement_content);
         let a1 = document.getElementById("artical1");
         let a2 = document.getElementById("artical2");
         a1.innerText = self.post1
         a2.innerText = self.post2
         self.submit();
      }).catch((e)=>{
         if(time < 5) {
            setTimeout(()=>self.loadComparedArticles(time + 1),1000)
         } else {
            self.modal.open('result')
            self.loadingCompare = false;
            self.loading = false;
         }
      });
   }
   closePage(){
      window.close();
   }
   getText(textHtml) {
      let hiddenField = document.querySelector("#hiddenTextField")
      if(!hiddenField) {
         hiddenField = document.createElement('div');
         hiddenField.style.display = 'none';
         hiddenField.id = "hiddenTextField";
      }
      document.body.appendChild(hiddenField);
      hiddenField.innerHTML = textHtml;
      
      return hiddenField.textContent;;
   }
   submit() {
       this.diffArticle()
       if (!this.post1 || !this.post2) {
           return this.message.error(this.translateFilter('page-similarity-text007'))
       }
           this.loading = true
           this.SimilarityCompareAPI.post({
               original_text: this.post1,
               compare_text: this.post2
           }).then(res => {
               this.percent = res.data.score
               this.loading = false
           })
   }


   diffArticle() {
       let a1 = document.getElementById("artical1");
       let a2 = document.getElementById("artical2");
       this.post1 = a1.innerText
       this.post2 = a2.innerText

       if (!this.post1 || !this.post2) {
           this.post1 = a1.innerText
           this.post2 = a2.innerText
           a1.innerHTML = this.post1
           a2.innerHTML = this.post2
           return
       }
       let d1 = this.strReplace(this.post1, 8);
       let d2 = this.strReplace(this.post2, 8);

       a1.innerHTML = d1
       a2.innerHTML = d2
       // console.log(this.post1)
       // console.log("----------------------------")
       // console.log(this.post2)
   }

   getRes(t1, t2, num, step) {
       let strList = [];
       let startLength = 0;
       let endLength = 0;
       function getStr(num, step) {
           let str = '';
           // console.log(num)
           if (num >= t1.length) {
               return strList
           }
           let finded = false;
           for (var i = num; i < t1.length; i++) {
               str = t1.substr(i, step)
               if (t2.indexOf(str) > -1) {
                   startLength = i
                   finded = true;
                   break;
               }
           }
           if(!finded) {
               return strList;
           }
           var n = 2;
           do {
               str = t1.substr(startLength, n)

               if (t2.indexOf(str) > -1) {
                   endLength = n
                   n++
               } else {
                   endLength = n - 1
                   break;

               }

           } while (n - 1 + startLength < t1.length)

           str = t1.substring(startLength, startLength + endLength)
           strList.push(str)
         
           // console.log(startLength)
           // console.log(endLength)
           if(num===endLength){
               return strList
           }
           return getStr(startLength + endLength, step)
       }

       return getStr(num, step)
   }

   strReplace(str, step) {//s1,s2 两篇文章内容
       let list;
       if (this.post1.length <= this.post2.length) {
           list = this.getRes(this.post1, this.post2, 0, step)
       } else {
           list = this.getRes(this.post2, this.post1, 0, step)
       }
       //    console.log(list)
       let res = str
       this.similarNum = 0;
       list = list.sort((a,b)=>b.length - a.length)
       list.forEach(e => {
           if(e.length>=8){
               this.similarNum+=e.length
               res = res.replace(e, "<span style='background-color: yellow;color:red;dispaly:inline-block'>" + e + "</span>")
           }
       })
       // console.log(this.similarNum)
       //console.log(res)
       return "<p>" + res + "</p>"
   }


}

export default SimilarityController;



// WEBPACK FOOTER //
// ./src/app/components/page/similarity/similarity.controller.js